<template>
	<div class="animated fadeIn">
		<b-row>
			<b-col lg="12" xl="12">
				<b-card>
					<div slot="header">
					<strong>{{this.$route.params.id == 'add' ? 'パターン追加' : 'パターン編集'}}</strong>
					</div>
          <b-form-group>
            <label for="category">カテゴリ</label>
            <b-form-select v-model="model.category" :options="codes.code_category"></b-form-select>
          </b-form-group>
          <b-form-group>
            <label for="ext">例外</label>
            <b-form-select v-model="model.ext" :options="codes.code_ext"></b-form-select>
          </b-form-group>
          <b-form-group>
            <label for="type">タイプ</label>
            <b-form-select v-model="model.type" :options="codes.code_type"></b-form-select>
          </b-form-group>
          <b-form-group>
            <label for="code">コード</label>
            <b-form-input md="5" type="text" id="code" v-model="model.code"></b-form-input>
          </b-form-group>
          <b-form-group>
            <label for="description">説明</label>
            <b-form-textarea :rows="3" v-model="model.description" id="descript"></b-form-textarea>
          </b-form-group>
          <b-form-group label="is_alive" label-for="ph_active" v-b-tooltip.hover>
            <c-switch v-model="model.is_alive"  :disabled="lock" color="success" label variant="pill"/><br>
          </b-form-group>
          <hr />
          <b-button size="sm" variant="primary" @click="test"> テスト </b-button>
          <b-button class="btn-add" size="sm" variant="success" @click="save"> 保存 </b-button>
          <b-button size="sm" variant="default" @click="cancel" class="btn-cancel"> キャンセル </b-button>
          <b-button size="sm" class="float-right text-white" variant="secondary" @click="list"> 一覧 </b-button>
				</b-card>
			</b-col>
		</b-row>
		<router-view></router-view>
	</div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
